export default function formatDate (input) {
  return new Date(input).toISOString().split('T')[0].replaceAll('-', '/')
}
